import { MEMBER_ROLE_OPTIONS } from '../members/memberConstants';

export const USER_STATS_PAGE_SIZE = 10;

export const USER_STATS_ROLE_OPTIONS = MEMBER_ROLE_OPTIONS;

function pad2(n) {
  return String(n).padStart(2, '0');
}

export function defaultUserStatsDateRange() {
  const now = new Date();
  const start = `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-01`;
  const end = `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
  return { startDateInput: start, endDateInput: end };
}

export function buildUserStatsPageParams(pageNo, filters = {}, pageSize = USER_STATS_PAGE_SIZE) {
  const params = {
    pageNo,
    pageSize,
  };
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }
  if (filters.startDateInput) {
    params.start = filters.startDateInput;
  }
  if (filters.endDateInput) {
    params.end = filters.endDateInput;
  }
  return params;
}

export function buildUserStatsExportParams(filters = {}, exportCurrentPageOnly, pageNo) {
  const params = buildUserStatsPageParams(pageNo || 1, filters, USER_STATS_PAGE_SIZE);
  params.exportCurrentPageOnly = exportCurrentPageOnly;
  params.fileName = 'member_daily_report';
  return params;
}

export function validateUserStatsDateRange(startDateInput, endDateInput) {
  if (!startDateInput || !endDateInput) {
    return '請選擇日期區間';
  }
  if (startDateInput > endDateInput) {
    return '開始日期不能晚於結束日期';
  }
  return '';
}

export function formatReportAmount(value) {
  if (value == null || value === '') {
    return '0';
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return String(value);
  }
  return num.toLocaleString(undefined, { maximumFractionDigits: 10 });
}

export function formatReportCount(value) {
  if (value == null || value === '') {
    return '0';
  }
  return String(value);
}
